import ajaxCrud from "@/services/ajaxCrud";
import { endpointMappingDisciplina } from "../../../constants";

export default {
  getAll(cb = null) {
    ajaxCrud.getAll(endpointMappingDisciplina, cb);
  },

  get(id, cb) {
    ajaxCrud.get(endpointMappingDisciplina, id, cb);
  },

  update(id, data = {}, cb) {
    ajaxCrud.update(endpointMappingDisciplina, id, data, cb);
  },

  create(data = {}, cb) {
    ajaxCrud.create(endpointMappingDisciplina, data, cb);
  },

  delete(id, cb) {
    ajaxCrud.delete(endpointMappingDisciplina, id, cb);
  },

  massDelete(ids, cb) {
    ajaxCrud.massDelete(endpointMappingDisciplina, ids, cb);
  },

  massUpdate(rows, cb) {
    ajaxCrud.massUpdate(endpointMappingDisciplina, rows, cb);
  },
};
